import { TetrazolioHookData } from '../../../hooks/useTetrazolio';
import { CanteiroAreiaHookData } from '../../../hooks/useCanteiroAreia';

interface Props {
  tetrazolioData: TetrazolioHookData | CanteiroAreiaHookData;
}

export default function FiltroSementesHeader({ tetrazolioData }: Props) {
  return (
    <div className="lista-sementes-filtro-header">
      <p className="lista-sementes-filtro-title">Filtrar</p>
      <button
        type="button"
        className="lista-sementes-filtro-subtitle"
        onClick={tetrazolioData.clearFilters}
      >
        Resetar filtros
      </button>
    </div>
  );
}
